import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import * as config from '../shared/config/app.config';
import { BaseService } from "../shared/services/base.service";
import { ExcelDownloadService } from "../shared/services/excel-download.service";


@Injectable({
  providedIn: 'root',
})
export class AccountOverviewService {
  cartId: any;
  userId: any;
  public userAccountIdDetailsData = new Subject<any>();
  public userReorderProducts = new BehaviorSubject<any>(null);
  userReorderProducts$ = this.userReorderProducts.asObservable();
  public reorderProductList = new BehaviorSubject<any>(null);
  reorderProductList$ = this.reorderProductList.asObservable();
  public paymentList = new BehaviorSubject<any>(null);
  paymentList$ = this.paymentList.asObservable();
  public offerEligibility = new BehaviorSubject<any>(null);
  offerEligibility$ = this.offerEligibility.asObservable();
  constructor(
    private readonly baseService: BaseService,
    public readonly excelService: ExcelDownloadService,
    private readonly http: HttpClient,
  ) { }

  public getAccountId() {
    this.baseService.get(config.GET_ACCOUNT_ID).subscribe((res) => {
      if (res !== null && res !== undefined && res?.length !== 0) {
        this.userAccountIdDetailsData.next(res);
      }
    });
  }

  public downloadXls(data, name, filenameNoChange = true) {
    this.excelService.exportAsExcelFile(data, name, filenameNoChange);
  }

  public uploadExcelOrder(userId, cartId, file) {
    return this.baseService.postfile(`${config.USER_ACCOUNT}${userId}/carts/${cartId}/upload-Order`, file);
  }

  public uploadExcelOrderStatus(userId, cartId) {
    return this.baseService.get(`${config.USER_ACCOUNT}${userId}/carts/${cartId}/upload-Order-Status`);
  }

  public uploadAccount(userId, cartId, params) {
    return this.baseService.post(`${config.USER_ACCOUNT}${userId}/carts/${cartId}/uploadOrder`, params);
  }

  public uploadAddToCart(userId, cartId, params) {
    return this.baseService.post(`${config.USER_ACCOUNT}${userId}/carts/${cartId}/uploadOrderFileStatus`, params);
  }

  public reorderProducts(compId, selectedLocation) {
    this.baseService.get(`/reOrder/component/${compId}?selectedLocations=${selectedLocation}&&fields=DEFAULT`).subscribe((res) => {
      if (res !== null && res !== undefined) {
        this.userReorderProducts.next(res);
      }
    });
  }

  getReorderProductList(products) {
    this.reorderProductList.next(null);
    this.baseService.get(`/reOrder/getProducts/${products}?fields=DEFAULT`).subscribe((res) => {
      if (res !== null && res !== undefined) {
        this.reorderProductList.next(res);
      }
    });
  }

  getPaymentList(userId, accountIds) {
    let url = `/my-account/${userId}/paymenthistory?pageSize=10&currentPage=0&timeFrame=30&fields=DEFAULT&sortCode=paymentDate&sortOrder=desc`;
    if (accountIds) {
      url = url + `&accountIds=${accountIds}`
    }
    this.baseService.get(url).subscribe((res) => {
      if (res !== null && res !== undefined) {
        this.paymentList.next(res);
      }
    });
  }

  getCustomerRep(baseSiteId, userId, b2bUnitId) {
    let params = {
      fields: 'DEFAULT',
      filter: true,
      showRepCondition: true
    }
    return this.baseService.get(`${config.USER_ACCOUNT}${userId}/b2bUnits/customerRepInfo`, params);
  }

  getSalesRep(baseSiteId, userId, b2bUnitId) {
    let params = {
      accountId: b2bUnitId,
      fields: 'DEFAULT'
    }
    return this.baseService.get(`${config.USER_ACCOUNT}${userId}/getSalesRepCard`, params)
  }

  orderTemplateDownload(baseSiteId) {
    return this.http.get(`assets/docs/${baseSiteId}/orderTemplate.json`);
  }

  getOfferEligibility(userName: string, b2bUnitId: string) {
    let url = `/users/${userName}/offers/eligible/${b2bUnitId}?fields=FULL`;
    this.baseService.get(url).subscribe(res => {
      if(res) {
        this.offerEligibility.next(res);
      }
    })
  }
}